import { Link } from "react-router-dom";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbNavProps {
  items: BreadcrumbItem[];
}

export default function BreadcrumbNav({ items }: BreadcrumbNavProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 text-base"></i>
            )}
            {item.path && !isLast ? (
              <Link
                to={item.path}
                className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-800 font-medium" : ""}>
                {item.label}
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
}